import { ORIGIN_OPTIONS } from '../constants/originSelection';

function findCharacterByKey(characters, key) {
  return (characters || []).find((character) => {
    const url = (character.imageUrl || '').toLowerCase();
    const name = (character.name || '').toLowerCase();
    if (key === 'savasci') {
      return url.includes('savasci') || name.includes('savaşçı') || name.includes('savasci');
    }
    if (key === 'sura') {
      return url.includes('sura') || name.includes('sura');
    }
    return false;
  });
}

function findAbilityByKey(abilityTypes, key) {
  return (abilityTypes || []).find((ability) => {
    const url = (ability.imageUrl || '').toLowerCase();
    const name = (ability.name || '').toLowerCase();
    if (key === 'fiziksel') {
      return url.includes('fiziksel') || name.includes('bedensel');
    }
    if (key === 'zihinsel') {
      return url.includes('zihinsel') || name.includes('zihinsel');
    }
    if (key === 'karabuyu') {
      return url.includes('karabuyu') || name.includes('kara büyü') || name.includes('kara buyu');
    }
    if (key === 'buyulu') {
      return url.includes('buyulu') || name.includes('büyülü silah') || name.includes('buyulu silah');
    }
    return false;
  });
}

/**
 * API'den gelen karakter ve yetenek listelerini köken seçeneklerine bağlar.
 * @returns {Record<string, { characterId: number, abilityTypeId: number }>}
 */
export function buildOriginResolutionMap(characters, abilityTypesByCharacterId) {
  const map = {};

  ORIGIN_OPTIONS.forEach((origin) => {
    const character = findCharacterByKey(characters, origin.characterKey);
    if (!character) return;

    const abilityTypes = abilityTypesByCharacterId[character.id] || [];
    const ability = findAbilityByKey(abilityTypes, origin.abilityKey);
    if (!ability) return;

    map[origin.id] = {
      characterId: character.id,
      abilityTypeId: ability.id,
    };
  });

  return map;
}
